export default __webpack_public_path__ + "images/icons/google_icon-ef10ada46926bbe14419eb2ac646dde7.svg";